// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reviewContainer_VBHz8 {
  text-align: center;
  width: 100%;
}

.subtitle_bGeoo {
  font-size: 20px;
  background: linear-gradient(
    to bottom right,
    var(--primary),
    var(--secondary)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 10px;
  font-weight: 500;
}

.title_vHqaV {
  font-size: 40px;
  color: var(--dark);
  margin-bottom: 50px;
}
.work_jyGwf{
  color: #959FA9;
  font-size: 13px;
}

.carousel_bRrpX {
  position: relative;
  overflow: hidden;
  width: 100%;
}

.cardsContainer_eUs0b {
  display: flex;
  transition: transform 0.5s ease-in-out;
  align-items: stretch;
}

.card_m_9ko {
  flex: 0 0 33.33%;
  max-width: 33.33%;
  padding: 22px;
  border-radius: 32px;
  text-align: left;
  background: var(--white-color);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: fit-content;
  margin: 0;
  opacity: 0.6;
  transform: scale(0.9);
  transition: all 0.3s ease;
  box-sizing: border-box;
  gap: 20px;
}
.clientName_bF_fE {
  font-weight: 300;
}
.activeCard_o7Vnz .clientName_bF_fE,
.activeCard_o7Vnz .text__PiUW {
  color: var(--_2-color);
}
.activeCard_o7Vnz {
  background: var(--white-color);
  transform: scale(1);
  opacity: 1;
  color: var(--_2-color);
  transition: all 0.2s ease-in-out;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
}

.cardContent_cczxW {
  display: flex;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  gap: 16px;
  img {
    margin-left: auto;
  }
}

.image_A185R {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #b3b3b3;
}

.clientName_bF_fE {
  font-size: 20px;
  font-weight: 400;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 20px;
  color: var(--_2-color);
}



.stars_qO2eV {
  display: flex;
}

.stars_qO2eV svg {
  font-size: 15px;
  color: #ffc107;
}

.text__PiUW {
  font-size: clamp(16px, 1vw, 20px);
  -webkit-user-select: none;
          user-select: none;
  font-weight: 300;
  color: var(--_2-color);
  line-height: 1.2;
  padding: 0 5px;
  width: 100%;
  height: auto;
  margin: 0;
}

.controls_N93ov {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 35px;
}

.controlButton_lciUm {
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 50%;
  border: 1px solid var(--9ca3af-color);
  background: var(--white-background);
  color: var(--white-background);
  font-size: 15px;
  cursor: pointer;
  transition: background 0.3s ease;
  svg {
    -webkit-transition: background 0.3s ease;
    -moz-transition: background 0.3s ease;
    -ms-transition: background 0.3s ease;
    -o-transition: background 0.3s ease;

    color: var(--_16c098-color);
  }
}

.controlButton_lciUm:hover {
  background: #1c987b;
  border: 1px solid #1c987b;
  svg {
    color: var(--white-background);
  }
}

@media (max-width: 992px) {
  .title_vHqaV {
    font-size: 35px;
  }
}

@media (max-width: 900px) {
  .card_m_9ko {
    flex: 0 0 100%;
    max-width: 85%;
  }
  .text__PiUW {
    font-size: 20px;
  }

  .carousel_bRrpX {
    margin-left: 50px;
  }
}

@media (max-width: 768px) {
  .title_vHqaV {
    font-size: 32px;
  }
}

@media (max-width: 768px) {
  .card_m_9ko {
    padding: 10px; 
  }
  .text__PiUW {
  }
}

@media (max-width: 500px) {
  .carousel_bRrpX {
    margin-left: clamp(10px, 7vw, 35px);
  }
  .text__PiUW {
    font-size: clamp(15px, 1vw, 18px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Carousel/Carousel.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf;;;;GAIC;EACD,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,SAAS;EACT;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;;;AAIA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC;IACE,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;;IAEnC,2BAA2B;EAC7B;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;IACd,cAAc;EAChB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;EACA;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,iCAAiC;EACnC;AACF","sourcesContent":[".reviewContainer {\n  text-align: center;\n  width: 100%;\n}\n\n.subtitle {\n  font-size: 20px;\n  background: linear-gradient(\n    to bottom right,\n    var(--primary),\n    var(--secondary)\n  );\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-bottom: 10px;\n  font-weight: 500;\n}\n\n.title {\n  font-size: 40px;\n  color: var(--dark);\n  margin-bottom: 50px;\n}\n.work{\n  color: #959FA9;\n  font-size: 13px;\n}\n\n.carousel {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}\n\n.cardsContainer {\n  display: flex;\n  transition: transform 0.5s ease-in-out;\n  align-items: stretch;\n}\n\n.card {\n  flex: 0 0 33.33%;\n  max-width: 33.33%;\n  padding: 22px;\n  border-radius: 32px;\n  text-align: left;\n  background: var(--white-color);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: fit-content;\n  margin: 0;\n  opacity: 0.6;\n  transform: scale(0.9);\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n  gap: 20px;\n}\n.clientName {\n  font-weight: 300;\n}\n.activeCard .clientName,\n.activeCard .text {\n  color: var(--_2-color);\n}\n.activeCard {\n  background: var(--white-color);\n  transform: scale(1);\n  opacity: 1;\n  color: var(--_2-color);\n  transition: all 0.2s ease-in-out;\n  -webkit-transition: all 0.2s ease-in-out;\n  -moz-transition: all 0.2s ease-in-out;\n  -ms-transition: all 0.2s ease-in-out;\n  -o-transition: all 0.2s ease-in-out;\n}\n\n.cardContent {\n  display: flex;\n  align-items: center;\n  user-select: none;\n  gap: 16px;\n  img {\n    margin-left: auto;\n  }\n}\n\n.image {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background-color: #b3b3b3;\n}\n\n.clientName {\n  font-size: 20px;\n  font-weight: 400;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  color: var(--_2-color);\n}\n\n\n\n.stars {\n  display: flex;\n}\n\n.stars svg {\n  font-size: 15px;\n  color: #ffc107;\n}\n\n.text {\n  font-size: clamp(16px, 1vw, 20px);\n  user-select: none;\n  font-weight: 300;\n  color: var(--_2-color);\n  line-height: 1.2;\n  padding: 0 5px;\n  width: 100%;\n  height: auto;\n  margin: 0;\n}\n\n.controls {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 35px;\n}\n\n.controlButton {\n  width: 56px;\n  height: 56px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  border-radius: 50%;\n  border: 1px solid var(--9ca3af-color);\n  background: var(--white-background);\n  color: var(--white-background);\n  font-size: 15px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n  svg {\n    -webkit-transition: background 0.3s ease;\n    -moz-transition: background 0.3s ease;\n    -ms-transition: background 0.3s ease;\n    -o-transition: background 0.3s ease;\n\n    color: var(--_16c098-color);\n  }\n}\n\n.controlButton:hover {\n  background: #1c987b;\n  border: 1px solid #1c987b;\n  svg {\n    color: var(--white-background);\n  }\n}\n\n@media (max-width: 992px) {\n  .title {\n    font-size: 35px;\n  }\n}\n\n@media (max-width: 900px) {\n  .card {\n    flex: 0 0 100%;\n    max-width: 85%;\n  }\n  .text {\n    font-size: 20px;\n  }\n\n  .carousel {\n    margin-left: 50px;\n  }\n}\n\n@media (max-width: 768px) {\n  .title {\n    font-size: 32px;\n  }\n}\n\n@media (max-width: 768px) {\n  .card {\n    padding: 10px; \n  }\n  .text {\n  }\n}\n\n@media (max-width: 500px) {\n  .carousel {\n    margin-left: clamp(10px, 7vw, 35px);\n  }\n  .text {\n    font-size: clamp(15px, 1vw, 18px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reviewContainer": `reviewContainer_VBHz8`,
	"subtitle": `subtitle_bGeoo`,
	"title": `title_vHqaV`,
	"work": `work_jyGwf`,
	"carousel": `carousel_bRrpX`,
	"cardsContainer": `cardsContainer_eUs0b`,
	"card": `card_m_9ko`,
	"clientName": `clientName_bF_fE`,
	"activeCard": `activeCard_o7Vnz`,
	"text": `text__PiUW`,
	"cardContent": `cardContent_cczxW`,
	"image": `image_A185R`,
	"stars": `stars_qO2eV`,
	"controls": `controls_N93ov`,
	"controlButton": `controlButton_lciUm`
};
export default ___CSS_LOADER_EXPORT___;
